import React, { useState } from 'react';
import { connect } from 'react-redux';
import { nextTask } from '../../study-logic/study-redux-slice'; // Import nextTask action
import { LikertEmotions } from '../../survey-tools/likert-scales'; // Import LikertEmotions component
import { Button, Typography, Grid } from '@mui/material';
import {PageContainer} from "../../survey-tools/ui-components/containers"
import {CustomConfirmationDialog} from '../../survey-tools/custom-dialogue'; // Adjust the import path as needed
import { shuffleArray } from '../../survey-tools/shuffle-and-sample'; 

function EmotionScale({ instanceId,nextTask }) {
    const [page, setPage] = useState(1);
    const [emotionData, setEmotionData] = useState(Array(20).fill(-99)); // Initialize with 20 emotions
    const [showDialog, setShowDialog] = useState(false);


    const emotions = [
    "Interested", "Distressed", "Excited", "Upset", "Strong",
    "Guilty", "Scared", "Hostile", "Enthusiastic", "Proud",
    "Irritable", "Alert", "Ashamed", "Inspired", "Nervous",
    "Determined", "Attentive", "Jittery", "Active", "Afraid"
    ]
    const [shuffledEmotions, setShuffledEmotions] = useState(shuffleArray([...emotions]));

    const handleNextClick = () => {
        if (page === 1) {
            setPage(2); // Move to the second page
        } else {
            // Check if all emotions are filled out
            const isComplete = emotionData.every(val => val !== -99);
            if (!isComplete) {
                setShowDialog(true); // Show confirmation dialog if not complete
            } else {
                const emotionRatings = {};

                shuffledEmotions.forEach((emotion, index) => {
                    emotionRatings[emotion] = emotionData[index];});
                
                nextTask({ data: { [instanceId]: emotionRatings } });
                console.log(emotionRatings)
            }
        }
    };

    return (
        <PageContainer>

        <Grid item xs={11} sm={9} md={7} lg={5}>
            {page === 1 && (
                <div>
                    <Typography gutterBottom>
                        Next, we will ask you to reflect on your current feelings.
                    </Typography>
                    <Button
                        onClick={handleNextClick}
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: '2em' }}
                    >
                        Next
                    </Button>
                </div>
            )}

            {page === 2 && (
                <div>
                    <LikertEmotions
                    prompt="Please indicate the extent to which you are experiencing the following emotions:"
                    handleUpdate={(data) => setEmotionData(data)}
                    emotions={shuffledEmotions}  // Pass shuffledEmotions as a prop
                    />
                    <Button
                        onClick={handleNextClick}
                        variant="contained"
                        color="primary"
                        sx={{ marginTop: '2em' }}
                    >
                        Next
                    </Button>

                <CustomConfirmationDialog
            open={showDialog}
            onClose={() => setShowDialog(false)}
            onConfirm={() => {
                setShowDialog(false);

                const emotionRatings = {};

                shuffledEmotions.forEach((emotion, index) => {
                    emotionRatings[emotion] = emotionData[index];});
                
                nextTask({ data: { [instanceId]: emotionRatings } });
                console.log(emotionRatings)
                
            }}
        />
                </div>
            )}
        </Grid>
                </PageContainer>

    );
}

const mapDispatchToProps = { nextTask };
export default connect(null, mapDispatchToProps)(EmotionScale);

